document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.hero-sign-up-form form');

    if (form) {
        const emailForm = document.querySelector('input[name="contact[email]"]');
        form.addEventListener('submit', function() {
            let email = emailForm?.value;
            localStorage.setItem('optin_email', email);
        });
    }

    const confirmation = document.querySelector('.content_block-content');

    if (confirmation) {
        const email = localStorage.getItem('optin_email');

        if (email && email != 'undefined') {
            confirmation.innerHTML = `
                ${window.confirmationMessage}
            `;
        } else {
            confirmation.innerHTML = `
               ${window.confirmationMessage}
        `;
        }
    }
});